import * as React from 'react';
import { translate } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
const { connect } = require('react-redux');
import { browserHistory } from 'react-router';
import { IStore } from 'redux/IStore';
import {
	setArticleStatus,
	getSuggestedArticleGalleries,
	setOpenGallery,
	setSelectedArticleGallery,
	getArticleCardByCode,
	getArticleCard,
} from 'modules/magazine/article/articlecard';
import { showModal, closeModal } from 'modules/modal';
import { IArticleCardData, IArticleCardAction } from 'models/magazine/article/articlecard';
import { IUserPreferences } from 'models/user/userpreferences';
import { IArticleComment } from 'models/magazine/article/articlecomment';
import { ISuggestedArticleGallery } from 'models/magazine/article/suggestedArticleGallery';
import * as c from 'models/constants';
import { ArticleStatus } from 'models/enums/statuses';
import { IModalAction } from 'models/modal';
import { IImageData } from 'models/common';
import { IArticleSearchResultsAction } from 'models/search/articlesearchresults';
import { IArticlesData, IArticlesAction } from 'models/magazine/article/articles';
import { ArticleHeader, ArticleCover, ArticleMobileNavigation } from 'components';
import { SimilarArticles, ErrorPage, AuthConsumer, ArticleFeaturedItems } from 'containers';
const { asyncConnect } = require('redux-connect');

import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { getMostReadArticles } from 'modules/magazine/article/recentarticles';
/** Next Article Module */
import { getNextArticle } from 'modules/magazine/article/nextarticle';
/** Similar Article Module */
import { getSimilarArticles } from 'modules/magazine/article/similararticles';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { detectIncompatibleBrowsers, formatInteger, thumbUrl } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { ArticleAuthorBanner } from 'components/Magazine/Article/ArticleCard/ArticleAuthorBanner';
import { actions as notifActions } from 'redux-notifications';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { ScrollIndicator } from 'components/Magazine/Article/ArticleCard/ScrollIndicator/ScrollIndicator';
import { Tags } from 'components/Magazine/Article/Tag/Tags';
import { ArticleComments } from 'containers/Administration/Articles/Comments/ArticleComments';
import AddArticleComment from '../../../../components/Common/AddComment/AddArticleComment';
require('./style.css');

interface IProps extends RouteComponentProps<IParams, {}> {
	articleCard: IArticleCardData;
	userPreferences: IUserPreferences;
	mostReadArticles?: IArticlesData;
	baseUrlClient?: string;
	similarArticles?: IArticlesData;
	nextArticle: IArticleCardData;
	getArticleCardByCode?: (code: string) => IArticleCardAction;
	getArticleCard?: (id: string, target?: string) => IArticleCardAction;
	setOpenGallery: (openGallery: boolean) => IArticleCardAction;
	setSelectedArticleGallery: (selectedArticleGallery: ISuggestedArticleGallery) => IArticleCardAction;
	getSuggestedArticleGalleries: (code: string, isSuggestedArticleGallery: boolean) => IArticleCardAction;
	setArticleStatus: (id: string, status: ArticleStatus) => IArticleCardAction;
	addNewCommentToList: (comment: IArticleComment) => IArticleCardAction;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	setLastSearchedKeyword?: (lastSearchedKeyword: string) => IArticleSearchResultsAction;
	getSimilarArticles?: (id: string) => IArticleCardAction;
	getNextArticle?: (id: string) => IArticleCardAction;
	getMostReadArticles?: () => IArticlesAction;
	t?: (key: string) => string;
	showNotification?: (message: string, kind: string) => void;
	dispatch?: any;
}

interface IParams {
	code: string;
}
@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params }) => {
			const articleCard = (getState as () => IStore)().articleCard;
			if (
				(!articleCard.item && params.code) ||
				(articleCard.item && params.code && params.code !== articleCard.item.code)
			) {
				return Promise.all([dispatch(getArticleCardByCode(params.code))]);
			}
		},
	},
])
@connect(
	(state: IStore) => ({
		articleCard: state.articleCard,
		userPreferences: state.userPreferences,
		baseUrlClient: state.fetchDefault.baseUrlClient,
		mostReadArticles: state.recentArticles,
		similarArticles: state.similarArticles,
		nextArticle: state.nextArticle,
	}),
	(dispatch) => ({
		dispatch,
		setArticleStatus: (id: string, status: ArticleStatus) => dispatch(setArticleStatus(id, status)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		getSuggestedArticleGalleries: (code: string, isSuggestedArticleGallery: boolean) =>
			dispatch(getSuggestedArticleGalleries(code, isSuggestedArticleGallery)),
		setOpenGallery: (openGallery: boolean) => dispatch(setOpenGallery(openGallery)),
		setSelectedArticleGallery: (selectedArticlegallery: ISuggestedArticleGallery) =>
			dispatch(setSelectedArticleGallery(selectedArticlegallery)),
		getArticleCardByCode: (code: string) => dispatch(getArticleCardByCode(code)),
		getArticleCard: (id: string, target?: string) => dispatch(getArticleCard(id, target)),
		getMostReadArticles: () => dispatch(getMostReadArticles()),
		getSimilarArticles: (id: string) => dispatch(getSimilarArticles(id)),
		getNextArticle: (id: string) => dispatch(getNextArticle(id)),
		showNotification: (message: string, kind: string, dismissAfter = 3000) =>
			dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleCard extends React.Component<IProps, {}> {
	public articleScrollingHeight: number = undefined;
	public articleSubMenu: HTMLElement = undefined;
	public articleNavNowReading: HTMLElement = undefined;
	public articleHeader: HTMLElement = undefined;
	public mainPageTitleHolder: HTMLElement = undefined;
	public galleryPreviewTitleDesktop: string = undefined;
	public galleryPreviewTitleResponsive: string = undefined;

	constructor(props) {
		super(props);

		this.approveArticle = this.approveArticle.bind(this);
		this.onNewCommentAdded = this.onNewCommentAdded.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.likeActionHandle = this.likeActionHandle.bind(this);
		this.copyUrlToClipboard = this.copyUrlToClipboard.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.backToTop = this.backToTop.bind(this);
		this.updateDimensions = this.updateDimensions.bind(this);
		this.openArticleGalleryModal = this.openArticleGalleryModal.bind(this);
		this.goToProfile = this.goToProfile.bind(this);
		this.getExcerpt = this.getExcerpt.bind(this);
		this.openSocialTab = this.openSocialTab.bind(this);
		this.getSuggestedArticleGalleriesAndOpenGalleryModal =
			this.getSuggestedArticleGalleriesAndOpenGalleryModal.bind(this);
	}

	public componentDidMount() {
		if (this.props.articleCard.item) {
			this.galleryPreviewTitleDesktop = this.getExcerpt(this.props.articleCard.item.galleryTitle, 40);
			this.galleryPreviewTitleResponsive = this.getExcerpt(this.props.articleCard.item.galleryTitle, 10);
		}

		this.articleSubMenu = document.getElementById('articleSubMenu');
		this.articleHeader = document.getElementById('articleHeaderHolder');
		this.mainPageTitleHolder = document.getElementById('portalNavHolder');
		this.articleNavNowReading = document.getElementById('articleNavNowReading');

		if (this.articleHeader != null && this.articleHeader != null) {
			this.articleScrollingHeight = this.articleHeader?.offsetHeight + this.mainPageTitleHolder?.offsetHeight;
		}

		window.addEventListener('resize', this.updateDimensions);
		this.props.getSimilarArticles(this.props.params.code);
		this.props.getNextArticle(this.props.params.code);
		this.props.getMostReadArticles();
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.articleCard.item &&
			this.props.articleCard.item &&
			prevProps.articleCard.item.id !== this.props.articleCard.item.id
		) {
			this.galleryPreviewTitleDesktop = this.getExcerpt(this.props.articleCard.item.galleryTitle, 40);
			this.galleryPreviewTitleResponsive = this.getExcerpt(this.props.articleCard.item.galleryTitle, 10);
		}
		if (!prevProps.articleCard.openGallery && this.props.articleCard.openGallery) {
			this.props.setOpenGallery(false);
			if (this.props.articleCard.selectedArticleGallery) {
				this.props.setSelectedArticleGallery(null);
				this.openArticleGalleryModal(
					this.props.articleCard.suggestedArticleGalleries,
					this.props.articleCard.selectedArticleGallery.galleryTitle,
					this.props.articleCard.selectedArticleGallery.galleryImages,
				);
			} else {
				this.openArticleGalleryModal(
					this.props.articleCard.suggestedArticleGalleries,
					prevProps.articleCard.item.galleryTitle,
					prevProps.articleCard.item.galleryImages,
				);
			}
		}

		if (!prevProps.userPreferences.id && this.props.userPreferences.id) {
			if (this.props.articleCard.item) {
				const likes = new Likes(LikeNodeType.ArticleCard);
				const wishlists = new Wishlists(WishlistNodeType.ArticleFeaturedProducts);
				this.props.dispatch(likes.getLikedItems());
				if (this.props.articleCard.item.itemsJArray && this.props.articleCard.item.itemsJArray.length > 0) {
					this.props.dispatch(wishlists.getWishlistedItems());
				}
			}
		}

		if (prevProps.params.code !== this.props.params.code) {
			this.props.getArticleCardByCode(this.props.params.code);
			this.props.getSimilarArticles(this.props.params.code);
			this.props.getNextArticle(this.props.params.code);
		}
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
	}

	public updateDimensions() {
		if (this.articleHeader != null && this.articleHeader != null) {
			this.articleScrollingHeight = this.articleHeader?.offsetHeight + this.mainPageTitleHolder?.offsetHeight;
		}
	}

	public backToTop() {
		const scrollToTop = window.setInterval(() => {
			const pos = window.pageYOffset;
			if (pos > 0) {
				if (detectIncompatibleBrowsers()) {
					document.body.scrollTo(0, pos - pos / 10);
				} else {
					window.scrollTo(0, pos - pos / 10);
				}
			} else {
				window.clearInterval(scrollToTop);
			}
		}, 16); //cca 60fps
	}

	public approveArticle() {
		this.props.setArticleStatus(this.props.articleCard.item.id, ArticleStatus.Approved);
	}

	public onNewCommentAdded(comment: IArticleComment) {
		this.props.addNewCommentToList(comment);
	}

	private likeItem(e: React.SyntheticEvent, isAuthenticated: () => any, signinRedirect: () => void) {
		e.preventDefault();
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ArticleCard);
			this.props.dispatch(likes.likeItem(this.props.articleCard.item.id));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(e: React.SyntheticEvent, isAuthenticated: () => any, signinRedirect: () => void) {
		e.preventDefault();
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ArticleCard);
			this.props.dispatch(likes.unlikeItem(this.props.articleCard.item.id));
		} else {
			signinRedirect();
		}
	}

	public getSuggestedArticleGalleriesAndOpenGalleryModal(
		e: React.SyntheticEvent,
		code: string,
		isSuggestedArticleGallery: boolean = false,
	) {
		if (e) {
			e.preventDefault();
		}

		if (isSuggestedArticleGallery) {
			this.props.closeModal();
		}
		this.props.getSuggestedArticleGalleries(code, isSuggestedArticleGallery);
	}

	public openArticleGalleryModal(
		suggestedArticleGalleries: ISuggestedArticleGallery[],
		galleryTitle: string,
		galleryImages: IImageData[],
	) {
		this.props.showModal('ArticleGallery', {
			galleryTitle,
			galleryImages,
			suggestedArticleGalleries,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
			openSuggestedArticleGallery: this.getSuggestedArticleGalleriesAndOpenGalleryModal,
			t: this.props.t,
		});
	}

	private getExcerpt(input: string, limit: number) {
		let excerpt = input;

		if (excerpt != null && excerpt.length > 0) {
			const trailing = excerpt.length > limit ? ' ...' : ' ';
			excerpt = excerpt.substr(0, excerpt.lastIndexOf('', limit)) + trailing;
		} else {
			excerpt = '';
		}

		return excerpt;
	}

	private openSocialTab(e: React.SyntheticEvent) {
		e.preventDefault();
		const articleNavTab = e.currentTarget.parentElement.parentElement;
		articleNavTab.classList.toggle('socialActive');

		if (articleNavTab.classList.contains('socialActive')) {
			this.articleNavNowReading.style.display = 'none';
		} else {
			this.articleNavNowReading.style.display = '';
		}
	}

	private goToProfile(userCode: string) {
		browserHistory.push('/profile/' + userCode);
	}

	private likeActionHandle(e: React.MouseEvent, isAuthenticated: any, signinRedirect: any): void {
		if (this.props.articleCard?.item?.isLiked) {
			this.unlikeItem(e, isAuthenticated, signinRedirect);
		} else {
			this.likeItem(e, isAuthenticated, signinRedirect);
		}
	}

	private copyUrlToClipboard(): void {
		const { t } = this.props;
		Promise.all([navigator.clipboard.writeText(window.location.href)])
			.then(() => {
				this.props.showNotification(
					t('Shop_ManageShop_Products_Import_Images_Label_Url') +
						' ' +
						t('BSPortal_Common_CopiedToClipboard').toLowerCase(),
					'success',
				);
			})
			.catch(() => {
				this.props.showNotification(t('ErrorPage500_ErrorLabel'), 'error');
			});
	}

	public render() {
		if (this.props.articleCard.error) {
			return <ErrorPage {...this.props} message={this.props.articleCard.message} />;
		}

		if (this.props.articleCard.isFetching || !this.props.articleCard.item) {
			return null;
		}

		const { t, similarArticles } = this.props;
		const {
			body,
			abstract,
			title,
			picture,
			addedBy,
			addedDate,
			authorPicture,
			status,
			tags,
			coverImages,
			// galleryImages,
			minutesToRead,
			userCode,
			isLiked,
			itemsJArray,
			viewCount,
			likesCount,
			comments,
			id,
		} = this.props.articleCard.item;

		const articleUrl = this.props.baseUrlClient + '/magazine/article/' + this.props.articleCard.item.code;

		let approveButton: JSX.Element = null;
		if (
			(this.props.userPreferences.isAdministrator || this.props.userPreferences.isEditor) &&
			status === ArticleStatus.InApproval
		) {
			approveButton = (
				<div className="approveBtn">
					<button disabled={picture && picture.length > 0 ? false : true} onClick={this.approveArticle}>
						{t('BSPortal_Common_Approve')}{' '}
					</button>
				</div>
			); /* add class approved for when article is already approved */
		}

		let avatarImage: JSX.Element = null;
		if (authorPicture) {
			avatarImage = <div className="imageHolder" style={{ backgroundImage: `url(${thumbUrl(authorPicture)})` }} />;
		}

		let featuredItems: JSX.Element = null;
		if (itemsJArray && itemsJArray.length > 0) {
			featuredItems = (
				<div className="container wrapperArticleSliderMagazine">
					<ArticleFeaturedItems items={itemsJArray} location={this.props.location} />
				</div>
			);
		}

		const renderActions = (
			type: Array<'views' | 'likes' | 'comments' | 'share' | 'save'>,
			isAuthenticated?: () => {},
			signinRedirect?: any,
			twoLines?: boolean,
		): JSX.Element => {
			return (
				<div className={`actionsContainer d-flex flex-row ${twoLines ? 'twoLines' : ''}`}>
					<div className="d-flex flex-row">
						{type.includes('views') ? (
							<div className="action actionView">
								<p className="p12 grayGigo">{formatInteger(viewCount)}</p>
								{renderIcon('views')}
							</div>
						) : null}
						{type.includes('likes') ? (
							<div className="action actionLike">
								{isLiked
									? renderIcon(
											'liked',
											22,
											22,
											'pointer',
											(e) => this.likeActionHandle(e, isAuthenticated, signinRedirect),
											true,
									  )
									: renderIcon(
											'like',
											22,
											22,
											'pointer',
											(e) => this.likeActionHandle(e, isAuthenticated, signinRedirect),
											true,
									  )}
								<p className={`p12 ${isLiked ? '' : 'grayGigo'}`}>{likesCount}</p>
							</div>
						) : null}
						{type.includes('comments') ? (
							<div className="action actionComments">
								<p className="p12 grayGigo">{comments.length ? comments.length : 0}</p>
								{renderIcon('comments', undefined, undefined, 'pointer', undefined, true)}
							</div>
						) : null}
					</div>

					<div className="d-flex flex-row">
						{type.includes('share') ? (
							<>
								<div className="action actionShare">
									<FacebookShareButton url={articleUrl} windowWidth={800} windowHeight={800}>
										{renderIcon('facebook', 22, 22, 'pointer', undefined, true)}
									</FacebookShareButton>
								</div>
								<div className="action actionShare">
									<TwitterShareButton url={articleUrl} windowWidth={800} windowHeight={800}>
										{renderIcon('twitter', 22, 22, 'pointer', undefined, true)}
									</TwitterShareButton>
								</div>
								<div className="action actionShare">
									{renderIcon('copyLink', 22, 22, 'pointer', this.copyUrlToClipboard, true)}
								</div>
							</>
						) : null}
					</div>
				</div>
			);
		};
		return (
			<AuthConsumer>
				{({ isAuthenticated, signinRedirect }) => {
					return (
						<div className="articleCardContainer">
							<ScrollIndicator />
							<div className="container containerFix">
								<div className="row">
									<div className="leftColumn col-lg-6 no_pad">
										<ArticleMobileNavigation
											articleUrl={articleUrl}
											backToTop={this.backToTop}
											isAuthenticated={isAuthenticated}
											signinRedirect={signinRedirect}
											isLiked={isLiked}
											nowReadingText={t('Magazine_Article_ArticleCard_Label_NowReading')}
											shareText={t('BSPortal_Common_Share')}
											title={title}
											openSocialTab={this.openSocialTab}
											likeItem={this.likeItem}
											unlikeItem={this.unlikeItem}
											articleScrollingHeight={this.articleScrollingHeight}
										/>
										<div>
											<Tags tags={tags} onClick={true} />
											<ArticleHeader
												approveButton={approveButton}
												userCode={userCode}
												title={title}
												abstract={abstract}
												avatarImage={avatarImage}
												addedBy={addedBy}
												addedDate={addedDate}
												minutesToRead={minutesToRead}
												t={t}
												goToProfile={this.goToProfile}
												viewCount={viewCount}
											/>
											{renderActions(['likes', 'share'], isAuthenticated, signinRedirect)}
											<div className="articleMainContent" dangerouslySetInnerHTML={{ __html: body }} />
											{renderActions(['likes', 'share'], isAuthenticated, signinRedirect, true)}
											<ArticleAuthorBanner userId={userCode} />
											<div className="articleCommentSection">
												<AddArticleComment articleId={id} t={t} key={0} />
												<ArticleComments articleId={id} />
											</div>
										</div>
									</div>
									<div className="rightColumn col-lg-6 no_pad">
										<ArticleCover coverImages={coverImages} />
										{featuredItems}
										<SimilarArticles
											similarArticles={similarArticles}
											getArticleCard={this.props.getArticleCard}
											tags={tags}
										/>
									</div>
								</div>

								<Helmet
									title={this.props.articleCard.item.metatagTitle || this.props.articleCard.item.title}
									link={[{ rel: 'canonical', href: articleUrl }]}
									meta={[
										{
											property: 'og:title',
											content: this.props.articleCard.item.metatagTitle || this.props.articleCard.item.title,
										},
										{
											property: 'og:image',
											content: this.props.articleCard.item.picture,
										},
										{
											property: 'og:description',
											content: this.props.articleCard.item.metatagDescription || this.props.articleCard.item.abstract,
										},
										{ property: 'og:url', content: articleUrl },
										{
											name: 'title',
											content: this.props.articleCard.item.metatagTitle || this.props.articleCard.item.title,
										},
										{
											name: 'description',
											content: this.props.articleCard.item.metatagDescription || this.props.articleCard.item.abstract,
										},
										{
											name: 'keywords',
											content: this.props.articleCard.item.metatagKeywords,
										},
									]}
								/>
							</div>
						</div>
					);
				}}
			</AuthConsumer>
		);
	}
}

export { ArticleCard };
